require.register("app/ui/modal/IFrame", function(exports, require, module){
  $0
  
});

